export default defineNuxtPlugin(() => {
    const pbc = ref()

    return {
        provide: {
            getPageBreadcrumbs: () => {
                return pbc.value
            },
            setPageBreadcrumbs: (bc: any) => {
                pbc.value = bc
            },
            resetPageBreadcrumbs: () => {
                pbc.value = []
            }

        }
    }
})
